export const INITIATED_PERMISSIONS = '__initiated__';
export const EMPTY_PERMISSIONS = '__empty__';
